import clsx from 'clsx';
import { ChangeEvent, forwardRef } from 'react';

import { CrossIcon } from '../../../assets/images/icons';
import styles from './MultiTextField.module.scss';

type TMultiTextFieldProps = {
  placeholder?: string;
  onChange: (inputValue: string, items?: string[]) => void;
  name?: string;
  id?: string;
  values: string[];
  inputValue: string
  variant?: 'secondary'
  fullWidth?: boolean
};

const MultiTextField = forwardRef<HTMLInputElement, TMultiTextFieldProps>(
  ({ fullWidth, id, inputValue, name, onChange, placeholder = '', values, variant }, ref) => {
    const inputHandler = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
      const trimmedValue = value.trim();
      if (trimmedValue.length > 0 && value[value.length - 1] === ' ') {
        onChange('', [...values, trimmedValue]);
      } else if (trimmedValue.length > 0 && trimmedValue.includes(' ')) {
        const newItems = trimmedValue
          .replace(/ {1,}/g, ' ')
          .split(' ')
          .filter(Boolean);
        onChange('', [...values, ...newItems]);
      } else {
        onChange(value, [...values]);
      }
    };

    const onDeleteBtnClick = (item: string) => {
      if (onChange) {
        onChange(
          inputValue,
          values.filter((elem) => elem !== item),
        );
      }
    };

    return (
      <div
        className={clsx(
          styles.multi_input,
          variant && styles[`multi_input__${variant}`],
          fullWidth && styles.multi_input__full_width,
        )}
      >
        {values.map((item) => (
          <div key={item} className={styles.tag}>
            {item}
            <div className={styles.delete} onClick={() => onDeleteBtnClick(item)}>
              <CrossIcon />
            </div>
          </div>
        ))}
        <input
          ref={ref}
          id={id}
          name={name}
          onChange={inputHandler}
          placeholder={!values.length && placeholder ? placeholder : ''}
          type="text"
          value={inputValue}
        />
      </div>
    );
  },
);

export { MultiTextField };
